
import { Suspense, lazy } from 'react';
import { NavBar } from "@/components/NavBar";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

const Footer = lazy(() => import("@/components/Footer"));

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen flex-col bg-stone-50 dark:bg-stone-950">
      <NavBar />

      <main className="flex flex-1 flex-col items-center justify-center px-4 text-center">
        <h1 className="mb-2 text-4xl font-bold text-stone-900 dark:text-white">Page not found</h1>
        <p className="mb-8 text-stone-600 dark:text-stone-500">
          Sorry, we couldn't find the page you're looking for.
        </p>
        <div className="flex gap-4">
          <Button
            onClick={() => navigate("/")}
            variant="outline"
            className="min-w-32 dark:border-stone-700 dark:bg-stone-800 dark:text-white dark:hover:bg-stone-700"
          >
            Go to Home
          </Button>
          <Button
            onClick={() => navigate("/dashboard")}
            className="min-w-32 bg-orange-500 hover:bg-orange-600"
          >
            Go to Dashboard
          </Button>
        </div>
      </main>

      <Suspense fallback={<div className="h-16" />}>
        <Footer />
      </Suspense>
    </div>
  );
};

export default NotFound;
